<template>
  <d-form @submit.prevent="save">
    <d-form-row>
      <d-col class="form-group">
        <label for="name">Anexar arquivo</label>
        <upload-files-list :model.sync="model.files"/>
      </d-col>
    </d-form-row>

    <d-form-row>
      <d-col cols="12"  class="form-group">
        <editor ref="comment" :model.sync="model.comment" placeholder="Comentário"></editor>
      </d-col>
    </d-form-row>
    <d-form-row class="mt-4">
      <d-col cols="12 blog-comments__actions">
        <d-button class="btn-white">
          <span class="text-success"><i class="material-icons">check</i></span> Responder
        </d-button>
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import TicketService from '_services/rest/modules/ticket';
import UploadFilesList from '_shared/UploadFilesList.vue';
import { MODEL_COMMENT, _LOAD_COMMENT_, _SAVE_MODEL_ } from './TicketModel';
import { cloneDeep } from '../../../utils';

export default {
  name: 'editor-ticket-chat',
  components: {
    Editor,
    UploadFilesList,
  },
  props: {
    ticketId: {
      type: Number,
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL_COMMENT),
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    save() {
      this.model.ticket_id = this.ticketId;
      TicketService.saveTicketComment(this.model)
        .then(() => {
          Events.$emit(_SAVE_MODEL_);
          this.model = cloneDeep(MODEL_COMMENT);
          this.activeAlert({ message: 'Resposta enviada com sucesso', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
  },
  mounted() {
    Events.$on(_LOAD_COMMENT_, comment => {
      this.model = { ...comment };
    });
  },
};
</script>
